import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=8b073292&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"
import style0 from "./TableList.vue?vue&type=style&index=0&id=8b073292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b073292",
  null
  
)

export default component.exports